import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NxaFAQ = () => {
  const [openQuestions, setOpenQuestions] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  // ✅ Corrected useEffect (moved outside the function)
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth <= 768);
    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // ✅ Fixed toggleQuestion function
  const toggleQuestion = (index) => {
    setOpenQuestions((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="pricing-sec-1 pricing-page-faq">
      <div className="container">
        <h2 className="font--31 color-293F  fw--400">NxaTel Pricing FAQs</h2>
        <div className="row">
          {/* Question 1 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">1</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(1)}
                    aria-expanded={openQuestions[1]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What is included in the NxaTel One plans?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[1] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Each plan includes cloud calling, call minutes, business
                    SMS, mobile and web apps, video meetings, and cloud storage.
                    Higher plans offer premium features like call routing,
                    analytics, and CRM integrations.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 2 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">2</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(2)}
                    aria-expanded={openQuestions[2]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Does NxaTel offer a free trial?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[2] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes, we offer a 14-day free trial with up to three users, 20
                    minutes of talk time per user, and three SMSs.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 3 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">3</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(3)}
                    aria-expanded={openQuestions[3]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Are there any setup or installation fees?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[3] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    No, NxaTel requires no setup fees. Activation takes only
                    three minutes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          {/* Question 4 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">4</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(4)}
                    aria-expanded={openQuestions[4]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Is there a contract or long-term commitment required?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[4] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    No. NxaTel plans are flexible and contract-free. You can
                    upgrade, downgrade, or cancel at any time.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 5 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">5</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(5)}
                    aria-expanded={openQuestions[5]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What payment methods does NxaTel accept?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[5] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    We accept credit and debit cards, EFT, PayStack, and debit
                    orders.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 6 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">6</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(6)}
                    aria-expanded={openQuestions[6]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I keep my existing business phone number?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[6] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes, you can port your current number to NxaTel at no
                    additional cost.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* Question 7 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">7</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(7)}
                    aria-expanded={openQuestions[7]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What happens if I exceed my plan’s usage limits?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[7] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    You can purchase additional credits or upgrade to a higher
                    plan.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 8 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">8</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(8)}
                    aria-expanded={openQuestions[8]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Are international calls included?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[8] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    International calling is available as an add-on package.
                    Contact sales for rates.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 9 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">9</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(9)}
                    aria-expanded={openQuestions[9]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    How do I upgrade, downgrade, or cancel my plan?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[9] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Manage your subscription via your NxaTel dashboard or
                    contact support at support@nxatel.co.za.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* partner logo */}
        <div className="sign-up-faq-partner-logo">
          <Link to="#" className="">
            <img src="./../assets/images/Method=Visa.svg" alt="logo" />
          </Link>
          <Link to="#" className="">
            <img src="./../assets/images/Mastercard.svg" alt="logo" />
          </Link>
          <Link to="#" className="">
            <img src="./../assets/images/Method=Stripe.svg" alt="logo" />
          </Link>
          <Link to="#" className="">
            <img src="./../assets/images/Ozwo Pay 1.svg" alt="logo" />
          </Link>
          {/* <Link to="#" className="">
            <img src="./../assets/images/voucher-log.svg" alt="logo" />
          </Link> */}
          {/* <Link to="#" className="">
            <img src="./../assets/images/blue-voucher.svg" alt="logo" />
          </Link> */}
          <Link to="#" className="">
            <img src="./../assets/images/nxa-voucher.svg" alt="logo" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NxaFAQ;
